import { IndexPath, SettingsTabsEnum } from '@/Config/app/router/index.path';

// Every surface that renders an UpgradePlanButton.
export const UPGRADE_CTA_SOURCES = [
  'kb_add_content_banner',
  'kb_auto_refresh_banner',
  'kb_article_auto_refresh',
  'kb_full_pill',
  'kb_limit_modal',
  'top_bar',
  'app_sidebar',
  'team_invite',
  'unspecified',
] as const;

export type UpgradeCtaSource = (typeof UPGRADE_CTA_SOURCES)[number];

export const UPGRADE_ENTRYPOINT_AGENT_MUTED_BANNER = 'agent_muted_banner';
export const UPGRADE_ENTRYPOINT_DIRECT = 'direct';

export type UpgradeEntrypoint =
  | UpgradeCtaSource
  | typeof UPGRADE_ENTRYPOINT_AGENT_MUTED_BANNER
  | typeof UPGRADE_ENTRYPOINT_DIRECT;

const TAGGABLE_ENTRYPOINTS = new Set<string>([
  ...UPGRADE_CTA_SOURCES,
  UPGRADE_ENTRYPOINT_AGENT_MUTED_BANNER,
]);

export const UPGRADE_SOURCE_QUERY_PARAM = 'upgrade_source';

export const BILLING_PLANS_ANCHOR = 'plans';

// `source` for checkouts begun on the Billing tab. Only `getting_started` changes backend
// behaviour (Stripe's cancel-return path), so a new value is metadata and analytics alone.
export const CHECKOUT_SOURCE_BILLING_PAGE = 'billing_page';

// Tags the CTA onto the URL so `billing_plans_viewed` can be joined back to the click.
export const buildBillingTabPath = (
  scenario: string,
  source: Exclude<UpgradeEntrypoint, typeof UPGRADE_ENTRYPOINT_DIRECT>,
): string =>
  `/i/${scenario}/${IndexPath.settings}?tab=${SettingsTabsEnum.Billing}` +
  `&${UPGRADE_SOURCE_QUERY_PARAM}=${encodeURIComponent(source)}`;

// The param is editable URL text, so unknown values must not reach PostHog as a free-form property.
export const getUpgradeEntrypoint = (searchParams: URLSearchParams): UpgradeEntrypoint => {
  const source = searchParams.get(UPGRADE_SOURCE_QUERY_PARAM);
  return source && TAGGABLE_ENTRYPOINTS.has(source)
    ? (source as UpgradeEntrypoint)
    : UPGRADE_ENTRYPOINT_DIRECT;
};
